module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/デュアルカメラモジュール.6bd275b1.png";